import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedUtilityRoutingModule } from './shared-utility-routing.module';
import { FormFieldComponent } from './form-field/form-field.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PrimeNgComponentsModule } from '../prime-ng-components/prime-ng-components.module';
import { PhoneMaskDirective } from './common/phone-mask/phone-mask.directive';
import { environment } from 'src/environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { DropDownComponent } from './drop-down/drop-down.component';
import { ZipCodeDirective } from './common/zip-code/zip-code.directive';
import { NumberLimitDirective } from './common/number-limit/number-limit.directive';
import { DndDirective } from './common/dnd/dnd.directive';
import { FormatPhonePipe } from './common/format-phone/format-phone.pipe';
import { NumberonlyDirective } from './common/numberonly.directive';
import { NumberformatDirective } from '../pages/registration-form/registration-form/numberformat.directive';


@NgModule({
  declarations: [FormFieldComponent, PhoneMaskDirective, DropDownComponent, ZipCodeDirective, NumberLimitDirective, DndDirective, FormatPhonePipe, NumberonlyDirective,NumberformatDirective],
  imports: [
    CommonModule,
    SharedUtilityRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    PrimeNgComponentsModule
  ],
  exports: [FormFieldComponent, PhoneMaskDirective, DropDownComponent, 
    ZipCodeDirective, NumberLimitDirective, DndDirective, FormatPhonePipe,NumberonlyDirective,NumberformatDirective],
  providers:[
    {
      provide: 'API_URL', useValue: {
        baseUrl: environment.baseUrl
      }
    },
    {
    provide: 'ECONSENT_URL', useValue: {
       baseUrl: environment.baseUrlEconsent
    }
    },
    {
      provide: 'API_URL_DOC', useValue: {
        baseUrl: environment.baseUrlDoc
      }
    }
  ]
})
export class SharedUtilityModule { }
